import {
  Paper,
  Toolbar,
  Typography,
  AppBar,
  IconButton,
  Modal,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import styled, { css } from "styled-components";

export const ModalMaterial = styled(Modal)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled(Paper)`
  ${({ size }) =>
    size === "large"
      ? css`
          width: 62%;
          height: 80%;
        `
      : css`
          width: 42%;
          height: 68%;
        `}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const HeadModal = styled(AppBar)``;

export const ModalTitleBar = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
`;

export const TitleModal = styled(Typography)``;

export const IconsButton = styled(IconButton)``;

export const CloseBtn = styled(Close)``;
